<template>
    <main role="main" class="py-4">
      <b-container class="container-xxl">
        <div class="d-flex flex-row align-items-center justify-content-between mb-4">
          <h4 class="m-0">{{ $t("manageConfigulation") }}</h4>
        </div>  
        <div class="d-flex flex-row align-items-center justify-content-between mb-3">
        <b-form inline @submit.prevent="onClickSearchBtn">
          <b-form-select class="mr-2" :options="filterCoreType" v-model="filterStatus" />
          <b-button type="submit" variant="primary">{{ $t("search") }}</b-button>
        </b-form>
        <div>
          <span v-if="totalItems && totalItems > 0" class="mr-3">{{ $t("resultCount", { count: totalItems }) }}</span>
          <b-button variant="outline-secondary" @click="onClickSearchBtn">
            <b-icon icon="arrow-clockwise"></b-icon> {{ $t("reload") }}
          </b-button>
          <b-button class="ml-4" variant="outline-primary" to="/admin-settings/api-config/new" v-if="isUserAdmin()">
            <b-icon icon="plus"></b-icon> {{ $t("createNew") }}
          </b-button>
        </div>
      </div>
  
        <b-table ref="table" :items="tableItemProvider" hover primary-key="id" :fields="tableFields" :busy="isLoading" show-empty>
        <template v-slot:table-busy>
          <div class="text-center text-secondary py-4">{{ $t("loadingData") }}</div>
        </template>
        <template v-slot:empty>
          <div class="text-center text-secondary py-4">{{ $t("noData") }}</div>
        </template>
        <template v-slot:cell(name)="data">
          <router-link :to="'/admin-settings/api-config/edit' + data.item.id">{{ data.item.name }}</router-link>
        </template>
        <template v-slot:cell(actions)="data">
          <!--<router-link :to="'/customers/details/' + data.item.id">{{ $t("details") }}</router-link>-->
          <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none p-0" no-caret right menu-class="shadow">
            <template v-slot:button-content>
              <b-icon icon="three-dots"/>
            </template>
            <b-dropdown-item :to="`/admin-settings/api-config/edit/${data.item.id}`">{{ $t("updateApiConfig") }}</b-dropdown-item>
            <b-dropdown-item-button  @click="onClickChangeStatus(data.item.id)">{{ $t("onOff") }}</b-dropdown-item-button>
          </b-dropdown>
        </template>
        </b-table>
      </b-container>
    </main>
  </template>
  
  <style lang="scss" scoped>
    .subscription-plan-item {
      font-size: 18px;
      line-height: 175%;
    }
    .button-padding {
      
      > button {
        padding: 0;
      }
    }
  </style>
  
  <script lang="ts">
    import {Component, Ref,  Vue} from 'vue-property-decorator';
    import _ from "lodash";
    import BaseComponent from "@/components/BaseComponent";
    import {BvTableFieldArray} from "bootstrap-vue";
    import {BTable, BvTableCtxObject, BvTableProviderPromiseResult} from "bootstrap-vue/src/components/table";
  
    import * as subscriptionPlanService from "@/service/subscriptionPlanService";
    import * as util from "@/service/util";
  
    @Component
    export default class ManagerConfig extends BaseComponent {
  
      selectedTab = true;
      totalItems = 0;
      isLoading = false;
      PlanTypes: any[] = null;
  
      filterStatus: string = '';
      filterCoreType = [];

      @Ref("table") table: BTable;
    tableFields: BvTableFieldArray = [
      {
        key: "id",
        label: "ID",
        thClass: "text-nowrap",
      },
      {
        key: "apiUrl",
        label: "URL",
        thClass: "text-nowrap",
      },
      {
        key: "coreType",
        label: "Core Type",
        thClass: "text-nowrap",
        tdClass: "text-break",
      },
      {
        key: "description",
        label: this.$t("packageType").toString(),
        thClass: "text-nowrap",
      },
      {
        key: "maxMeetings",
        label: this.$t("numMeeting").toString(),
        thClass: "text-nowrap",
      },
      {
        key: "maxParticipants",
        label: this.$t("meetingParticipant").toString(),
        thClass: "text-nowrap",
        tdClass: "text-break",
      },
      {
        key: "active",
        label: this.$t("status").toString(),
        formatter: this.getStatus,
        thClass: "text-nowrap",
        tdClass: "text-break",
      },
      {
        key: "actions",
        label: "",
        thClass: "text-nowrap",
      }
    ]; 
      mounted() {
        this.fetchPlans();
        this.onSelectTab(1);
      }
  
      onSelectTab(tab) {
        this.fetchPlans(tab);
      }

      getStatus(value) {
        return value ? this.$t("active").toString()  : this.$t("unactive").toString() ;
      }
  
      async fetchPlans(active = true) {
        try {
          this.isLoading = true;
          this.PlanTypes = null;
          this.filterCoreType = await subscriptionPlanService.getPlanTypeList();
          this.filterCoreType.unshift( { value: '', text: this.$t("all").toString() });
  
        } catch (e) {
          this.toastError(e);
  
        } finally {
          this.isLoading = false;
        }
      }
  
      onClickSearchBtn() {
        this.table.refresh();
      }

      async tableItemProvider(ctx: BvTableCtxObject): Promise<BvTableProviderPromiseResult> {
      try {
        const customerListRes = await subscriptionPlanService.getCorePlanTypeList({type: this.filterStatus});

        this.totalItems = customerListRes.total;
        return customerListRes;

      } catch (e) {
        this.toastError(e);
        return [];
      }
    }
  
      async onClickChangeStatus(id) {
        try {
        await subscriptionPlanService.actionCorePlanType(id);   
        this.table.refresh();       
        } catch (error) {
          this.toastError(error);
        }
    }
  }
  </script>
  